import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddSimpleIcon, Block, DefaultText, IconButton, SelectOption, SmallText } from '@guryou/html-components';
import { addMinutes, getWeekDay, printInputDate, printInputTime } from '@guryou/utils/build/dateTimeUtils';
import WeekDateItem from './WeekDateItem';

const workingDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const daysMap = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  0: 'Sunday',
};
const getDaysOptions = t => {
  return workingDays.map((lab, val) => ({ value: val === 6 ? '0' : val + 1, label: t(`DAYS.${lab}`) }));
};

const dateToISOLikeButLocal = () => {
  const date = new Date();
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  const msLocal = date.getTime() - offsetMs;
  const dateLocal = new Date(msLocal);
  const iso = dateLocal.toISOString();
  const isoLocal = iso.slice(0, 19);
  return isoLocal;
};

const WeekBuilder = ({ gyClass, ls }) => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState();

  const [requiredDay, setRequiredDay] = useState('');
  const error = false;

  const handleDeleteDay = id => {
    setAddedDays(prev => prev.filter(day => day.id !== id));
  };

  const [addedDays, setAddedDays] = useState(() => {
    const weekDay = getWeekDay(dateToISOLikeButLocal());
    // if (state?.data?.addedDays) {
    //   return state?.data?.addedDays.map(day => ({ ...day, dayOfWeekText: t(`DAYS.${daysMap[day.dayOfWeek]}`) }));
    // }
    return [
      {
        id: Date.now() + Math.random() * 1000,
        duration: ls.duration,
        price: +gyClass?.price || 0,
        startTime: printInputTime(ls.startTime),
        endTime: printInputTime(addMinutes(ls?.startTime, ls?.duration)),
        startDate: printInputDate(ls?.startDate),
        endDate: printInputDate(ls?.endTime || new Date()),
        dayOfWeek: weekDay,
        dayOfWeekText: t(`DAYS.${daysMap[weekDay]}`),
      },
    ];
  });

  const handleAddDay = selectedDay => {
    if (!selectedDay) {
      setRequiredDay(t('NOTIFICATIONS.pleaseSelect'));
      return;
    }
    const newDay = {
      id: Date.now() + Math.random() * 1000,
      duration: +ls?.duration || 5,
      price: +gyClass?.price || 0,
      startTime: printInputTime(ls.startTime),
      endTime: printInputTime(addMinutes(ls.startTime, ls?.duration)),
      startDate: printInputDate(ls.startDate),
      endDate: printInputDate(ls?.endTime || new Date()),
      dayOfWeek: +selectedDay,
      dayOfWeekText: t(`DAYS.${daysMap[+selectedDay]}`),
    };
    setAddedDays(prev => [...prev, newDay]);
    // setAddedDaysError(false);
    setRequiredDay('');
  };

  return (
    <Block xs={12} margin={0} padding={0}>
      <Block margin={0} padding={0} display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
        <Block xs={6.2} margin={0} padding={0}>
          <DefaultText fontWeight={800}>{t('SESSIONS.startBuildWeek')}</DefaultText>
        </Block>
        <Block xs={5.8} display="flex" flexDirection="row" alignItems="center" margin={0} justifyContent="end">
          <Block margin={0} padding={0} paddingBottom={6} textAlign="left">
            <SelectOption
              margin="none"
              none={false}
              onChange={day => setSelectedDay(day)}
              options={getDaysOptions(t)}
              label={t('SESSIONS.selectDay')}
            />
            {requiredDay && <SmallText color="red">{requiredDay}</SmallText>}
          </Block>
          <IconButton icon={AddSimpleIcon} onClick={() => handleAddDay(selectedDay)} label={t('SESSIONS.addDay')} />
        </Block>
      </Block>

      {addedDays?.map((day, index) => (
        <WeekDateItem day={day} gyClass={gyClass} key={day.id} name={`addedDays[${index}]`} handleDeleteDay={handleDeleteDay} />
      ))}
      {error && <SmallText color="red">{`* ${t('SESSIONS.selectDay')}`}</SmallText>}
    </Block>
  );
};

export default WeekBuilder;
